/**
 * Date format string for message timestamps in the chat.
 * Format: "h:mm:ssaaa" (e.g., "1:30:45pm")
 */
export const MESSAGE_TIME_FORMAT = "h:mm:ssaaa";
